import { Model, type ModelProps } from '@/infra/model'
import { Id } from '@/infra/id'
import { observable } from 'mobx'
import { unixEpoch } from '@/utils/date-util'

/**
 * An account merge request's status.
 */
export type AccountMergeRequestStatus =
  'Requested' | 'Rejected' | 'Linked' | 'Ignored'

export type AccountMergeRequestProps = ModelProps<AccountMergeRequest>

export class AccountMergeRequest extends Model<AccountMergeRequest> {
  id = Id.none

  @observable accessor displayName = ''
  @observable accessor email = ''
  @observable accessor primaryAccountId = Id.none
  @observable accessor duplicateAccountId = Id.none
  @observable accessor status: AccountMergeRequestStatus = 'Requested'
  @observable accessor picture = ''
  @observable accessor ticketId = ''
  @observable accessor dateCreated = unixEpoch()
}
